export default __webpack_public_path__ + "static/media/Inclusion.79979873.svg";